import { IScale, ISeriaConfig, ScaleType } from "../types";
import Line from "./Line";
import { locator } from "../helpers/common";

export default class Scatter extends Line {
	addScale(type: ScaleType, scale: IScale): void {
		if (type === "bottom" || type === "top") {
			this.xScale = scale;
			this._xLocator = locator(this.config.value);
		} else {
			this.yScale = scale;
			this._yLocator = locator(this.config.valueY);
		}
	}

	protected _setDefaults(config: ISeriaConfig) {
		const defaults = {
			active: true,
			tooltip: true,
			pointType: "rect",
		};
		this.config = { ...defaults, ...config } as ISeriaConfig;
		const point = this.config.pointType;
		const color = this.config.pointColor || this.config.color;

		if (point) {
			this._drawPointType = this._getPointType(point, color);
		}
	}
}
